import * as React from "react";
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  TableHead,
  Box,
} from "@mui/material";

const OptionsForRangeAndValues = ({ data }) => {
  return (
    <div style={{ maxHeight: "600px", overflowY: "auto" }}>
      <Table sx={{ width: "100%" }}>
        {/* Table header (optional) */}
        <TableHead>
          <TableRow>
            <TableCell>Label</TableCell>
            <TableCell>Color</TableCell>
            <TableCell>Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.legends.map((row) => (
            <TableRow key={row.label}>
              {/* Condition column */}
              <TableCell>
                <Typography variant="body2">{row.label}</Typography>
              </TableCell>
              <TableCell>
                <Box
                  sx={{
                    width: '14px',
                    height: '14px',
                    backgroundColor: row.color,
                    border: '1px solid rgba(0, 0, 0, 0.2)',
                    borderRadius: '4px'
                  }}
                />
              </TableCell>

              <TableCell>
                <Typography variant="body2">{row.value}</Typography>
              </TableCell>
            </TableRow>
          ))}
          {/* <TableRow key={"scale"}>
          <TableCell>
            <Typography variant="body2">scale</Typography>
          </TableCell>

          <TableCell>
            <Typography variant="body2">{data.scale}</Typography>
          </TableCell>
        </TableRow> */}
        </TableBody>
      </Table>
    </div>
  );
};

export default OptionsForRangeAndValues;
